/**
 * Phase 3 feature-flag gate (P3.0.1).
 * Reads VITE_FEATURE_PHASE3 at module load. Phase 3 engine entry points check
 * isPhase3Enabled() before running; with the flag off, no Phase 3 code executes.
 */
export function isPhase3Enabled(): boolean {
  return Boolean(import.meta.env.VITE_FEATURE_PHASE3);
}
